module.exports = { raw: '8.6.0' };



//////////////////
// WEBPACK FOOTER
// ./~/auth0-js/src/version.js
// module id = 55
// module chunks = 0